import Raven from 'raven-js';
import { InMemoryCache } from '../cache/InMemoryCache';
import { hubsSettingClient } from '../client/hubsSettingsClient';
const fetchSetting = ({
  settingName,
  defaultValue
}, client) => {
  return hubsSettingClient.withHttpClient(client).fetch(settingName, defaultValue).catch(err => {
    Raven.captureException(err);
    return defaultValue;
  });
};
export const HubsSettingsCache = new InMemoryCache('HubsSettingsCache', fetchSetting, ({
  settingName
}) => settingName);

// exported for unit test usage only
export const _resetCache = () => {
  HubsSettingsCache.clear();
};